import { Flex, Icon, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { Biology } from '../icons/biology';
import { Chemistry } from '../icons/chemistry';
import { Geography } from '../icons/geography';
import { History } from '../icons/history';
import { MathIcon } from '../icons/math';
import { Philosophy } from '../icons/philosophy';
import { Physics } from '../icons/physics';
import { Religion } from '../icons/religion';
import { Turkish } from '../icons/turkish';

type CourseType = 'test' | 'lesson' | 'video';

type Topic =
  | 'math'
  | 'physics'
  | 'biology'
  | 'turkish'
  | 'philosophy'
  | 'geometry'
  | 'chemistry'
  | 'geography'
  | 'history'
  | 'literature'
  | 'religion';

export type CourseElementType = {
  topic: Topic;
  type: CourseType;
  title: string;
  // difficulty: number;
  // views: number;
};

const colors = {
  test: {
    color: `#00508b`,
    bgGradient: `linear-gradient(220deg, rgb(27, 160, 242) 0%, rgb(2, 82, 133) 97%)`,
  },
  lesson: {
    color: `#1e8ec3`,
    bgGradient: `linear-gradient(227deg, rgb(27, 160, 242) 0%, rgb(106, 195, 203) 100%)`,
  },
  video: {
    color: `#eb483f`,
    bgGradient: `linear-gradient(224deg, rgba(242,129,29,1) 0%, rgba(242,114,70,1) 29%, rgba(242,102,102,1) 95%)`,
  },
};

const CourseElement = ({
  // difficulty,
  title,
  topic,
  type,
}: // views,
CourseElementType) => {
  const { t } = useTranslation(`common`);
  const TopicIcon = (() => {
    switch (topic) {
      case `biology`:
        return Biology;
      case `chemistry`:
        return Chemistry;
      case `geography`:
        return Geography;
      case `history`:
        return History;
      case `math`:
        return MathIcon;
      case `philosophy`:
        return Philosophy;
      case `physics`:
        return Physics;
      case `religion`:
        return Religion;
      case `turkish`:
      case `literature`:
        return Turkish;
      default:
        return Icon;
    }
  })();
  return (
    <Flex
      overflow="hidden"
      bg={colors[type]?.bgGradient}
      direction="column"
      justify="start"
      p="3"
      position="relative"
      mx={[1, null, 2]}
      borderRadius="lg"
      boxSize={[`123px`, null, `180`]}
    >
      <Flex
        justify="space-between"
        align="center"
        color="#f4f4f4"
        direction="row"
        fontSize={[`sm`, null, `md`]}
      >
        {t(`resources.topics.${topic}`)}
        <Image boxSize={[3, null, 5]} src={`/images/courses/${type}.svg`} />
      </Flex>
      <Text
        sx={{ wordSpacing: `400px` }}
        lineHeight="1.7"
        fontWeight="bold"
        fontSize={[`md`, null, `lg`]}
        color="white"
      >
        {title}
      </Text>
      <TopicIcon
        position="absolute"
        bottom="3"
        right="3"
        boxSize={[6, null, 14]}
        color={colors[type]?.color}
      />
    </Flex>
  );
};

export default CourseElement;
